<!-- Form Control global de texte -->
<mat-form-field [appearance]="appearance" [ngClass]="readOnly ? 'disabled' : ''">
    <mat-label>{{ label ?? placeholder }}</mat-label>
    <input
        [required]="control.isRequired"
        [readonly]="readOnly"
        [type]="ctype"
        matInput
        [formControl]="control"
        [name]="control.name"
        [max]="max"
        [min]="min"
        [errorStateMatcher]="matcher"
        [maxlength]="control.maxLengthValue"
        [placeholder]="placeholder"
        id="{{ parameterId }}"
    />
    <mat-icon matSuffix *ngIf="iconName" [ngStyle]="{ color: iconColor }">{{ iconName }}</mat-icon>
    <mat-hint *ngIf="displayHint" align="end"
        ><span *ngIf="control.value">{{ control.value.length }}</span
        ><span *ngIf="!control.value">0</span> / {{ control.maxLengthValue }}</mat-hint
    >

    <!-- Clear Button -->
    <button
        mat-icon-button
        *ngIf="showClearButton && control.value"
        matSuffix
        aria-label="Clear"
        (click)="control.setValue(null)"
    >
        <mat-icon>close</mat-icon>
    </button>

    <!-- https://github.com/angular/material2/issues/7739 : Vive la bidouille ! -->
    <ng-template ngFor let-key [ngForOf]="control.validationKeys" ngProjectAs="mat-error">
        <mat-error *ngIf="control.hasError(key)">
            {{ control.getErrorMessage(key) }}
        </mat-error>
    </ng-template>
</mat-form-field>
